export type ProofTone = 'blue' | 'emerald' | 'indigo' | 'rose' | 'violet'

type ProofBase = {
  id: string
  author: string
  role?: string
  content: string
  tone: ProofTone
}

export type Proof =
  | (ProofBase & {
      kind: 'review'
      source: 'google'
      rating: number
    })
  | (ProofBase & {
      kind: 'chat'
      source: 'discord'
      timestamp: string
    })
  | (ProofBase & {
      kind: 'sms'
      source: 'sms'
      timestamp: string
    })

/** Desktop shows this many before "Pokaż wszystkie". Current set balances - bump only when bottoms still align. */
export const DESKTOP_COLLAPSED_PROOF_COUNT = 11

export const proofs: Proof[] = [
  {
    id: 'karol-kowalczyk',
    kind: 'review',
    source: 'google',
    author: 'Karol Kowalczyk',
    role: 'Superteam Poland',
    tone: 'blue',
    rating: 5,
    content:
      'Bardzo polecam. Bardzo wartościowe zajęcia prowadzone z prawdziwą pasją. Świetne, kompleksowe przygotowanie do rozmowy o pracę - dostałem pytania, które pokryły się 1:1 z tym, co przerabialiśmy na zajęciach.'
  },
  {
    id: 'marek-kazimierczak',
    kind: 'chat',
    source: 'discord',
    author: 'Marek',
    role: 'Laureat Olimpiady Informatycznej i Olimpiady Informatycznej Juniorów',
    tone: 'indigo',
    timestamp: '21.03.2026, 18:18',
    content:
      'Bardzo dziękuję za wszystkie lata zajęć. Dzięki Panu nauczyłem się bardzo dużo. Planuję iść na JSIM i również zamierzam kontynuować algorytmikę. Jeszcze raz dziękuję za czas, który Pan mi poświęcił, bez Pana nie udało by mi się tyle się nauczyć z informatyki.'
  },
  {
    id: 'jakub-parapura',
    kind: 'review',
    source: 'google',
    author: 'Jakub Parapura',
    role: 'Software Engineer w Google',
    tone: 'rose',
    rating: 5,
    content:
      'Ukończyłem kurs "Przygotuj się do interview" i mogę go polecić każdemu, kto chce na poważnie podejść do doskonalenia umiejętności rozwiązywania algorytmicznych zadań rekrutacyjnych.\n\nZ kursu można wynieść najwięcej, inwestując czas w samodzielne rozwiązywanie zadań dołączonych do każdych zajęć. Są one dostosowane do różnych poziomów uczestników, a przy tym na tyle ciekawe, że uważam je za lepsze niż wiele popularnych zestawów dostępnych w internecie.\n\nRadek, prowadzący zajęcia, wykazuje się ogromną cierpliwością i chęcią nauczenia - nawet gdy nie potrafiłem dokładnie nazwać, czego nie rozumiem, poświęcał czas, żeby mi to wytłumaczyć. Co więcej, nie ogranicza się tylko do materiału kursowego - chętnie odpowiada na pytania związane z rozwojem kariery, dzięki czemu uzyskałem odpowiedzi, których samodzielnie i bezskutecznie szukałem przez lata.\n\nPodoba mi się również to, że prowadzący aktywnie zbiera opinie uczestników i eksperymentuje z metodami nauczania, zamiast bazować na szkolno-uczelnianym podejściu opartym na przekazywaniu wiedzy encyklopedycznej.\n\nPolecam!'
  },
  {
    id: 'piotr-kotaba',
    kind: 'review',
    source: 'google',
    author: 'Piotr Kotaba',
    role: 'Tata licealistki',
    tone: 'emerald',
    rating: 5,
    content: 'Polecam serdecznie - doskonałe efekty w nauce.'
  },
  {
    id: 'woytuloo',
    kind: 'review',
    source: 'google',
    author: 'WoyTuloo',
    tone: 'emerald',
    rating: 5,
    content:
      'Dzięki wsparciu AlgoAcademy udało mi się zdobyć pierwszą pracę w IT w zaledwie dwa miesiące. Gorąco polecam współpracę z nimi.'
  },
  {
    id: 'bartosz-warchol',
    kind: 'review',
    source: 'google',
    author: 'Bartosz Warchoł',
    role: 'Software Engineer w Samsung',
    tone: 'violet',
    rating: 5,
    content:
      'Korzystam z mentoringu i myślę, że moja opinia może komuś pomóc 🙂\n\nMentoring u Radka to program skoncentrowany na rozwoju. Indywidualnie dobrane zadania, stały kontakt z mentorem i wiele innych elementów umożliwiają naprawdę szybki postęp.\n\nMentoring oparty jest na uczeniu poprzez praktykę. Teoria nie jest podawana przed partią zadań, ale raczej krystalizuje się w TRAKCIE ich robienia. Na początku miałem jednak wątpliwości co do skuteczności tego podejścia. Wydało mi się ono bardzo chaotyczne. Z czasem wprowadzaliśmy nawyki, które pozwoliły wyciągnąć z zadań jak najwięcej wniosków np. poprzez zadawanie odpowiednich pytań, zapisywanie obserwacji, popełnionych błędów, itd. Sprawiło to, że zacząłem samemu dochodzić do pewnych przemyśleń, które z pomocą mentora, przekuwałem w teorię.\n\nAle trzeba nastawić się, że nie będzie to lekka droga, bo jak to twierdzi mój mentor - prawdziwe uczenie się zaczyna tam, gdzie kończy się strefa komfortu.\nJeżeli nigdy nie doświadczyłeś uczenia poprzez praktykę, to początek może być, tak jak u mnie - wypełniony buntem wobec tej metody, ale warto jej zaufać i kontynuować podróż 🙂\n\nPS. Korzystaj z możliwości zadawania pytań mentorowi. Ja zacząłem to robić zbyt późno i bardzo tego żałuję...\n\nZdecydowanie polecam 🙂'
  },
  {
    id: 'michal-miziolek',
    kind: 'review',
    source: 'google',
    author: 'Michał Miziołek',
    tone: 'indigo',
    rating: 5,
    content:
      'Radosław - osoba, która prowadzi firmę, jest niezwykle utalentowanym człowiekiem i bardzo dokładnie wie, na czym polega nauczanie. Nie mówię tutaj tylko o sporych umiejętnościach w przekazywaniu wiedzy oraz wieloletnim doświadczeniu, ale również o świadomości, jak bardzo można zmienić człowieka, po prostu będąc dobrym mentorem. Na tyle, ile udało mi się poznać Radosława, wiem, że to, co robi, to nie tylko czysta praca i cel, lecz droga, przy której zawsze jest obok. Niezależnie od problemu zawsze daje niebanalne analogie oraz ciekawe zagadki, które otwierają kompletnie nowe pole widzenia za każdym razem. Sam fakt umiejętności połączenia ogromnej wiedzy teoretycznej wraz z przecudownymi analogiami wykorzystywania ich w codziennym życiu jest czymś, co zawsze wzbudza we mnie dreszcze ekscytacji. Muszę serio podkreślić, świetną metodykę przekazywania wiedzy, gdzie zawsze to właśnie uczeń dochodzi sam do wniosków i rezultatu, będąc kierowany odpowiednimi pytaniami i analogiami przez Radosława. Nigdy bym nie pomyślał, że może istnieć dobry system edukacji, a jednak życie zaskakuje. Mógłbym pisać godzinami, jak wiele świetnych technik poznałem dzięki Niemu, jednak trzeba to przeżyć samemu!\n\nŻyczę każdemu możliwości poznania i posiadania takiej osoby jak Radosław, bo jest to dosłownie doświadczenie odmieniające życie :)'
  },
  {
    id: 'szymon-wroblewski',
    kind: 'chat',
    source: 'discord',
    author: 'Szymon',
    role: 'Finalista Olimpiady Informatycznej',
    tone: 'indigo',
    timestamp: '12.02.2026, 19:42',
    content:
      'mam 100, 100, 50, 18 - razem 268 punktów (...)\nZajęcia z Panem były bardzo wartościowe.\n\nDziękuję!'
  },
  {
    id: 'anna-i-robert',
    kind: 'sms',
    source: 'sms',
    author: 'Anna i Robert',
    role: 'Rodzice ósmoklasisty, laureata OIJ',
    tone: 'blue',
    timestamp: '21.04.2026, 20:41',
    content:
      'Dobry wieczór, syn został laureatem 2 stopnia. Zajęcia bardzo mu się podobały i chcielibyśmy wrócić po wakacjach. Bardzo dziękujemy!'
  },

  {
    id: 'jan-gregorczuk',
    kind: 'chat',
    source: 'discord',
    author: 'Jan',
    role: 'Finalista Olimpiady Informatycznej',
    tone: 'violet',
    timestamp: '03.03.2026, 18:41',
    content:
      'Bardzo bardzo dziękuję! (...)\n\nTym bardziej cieszę się, że udało mi się zrobić finał! Uważam, że bardzo dużo zawdzięczam Panu, dlatego szczerze dziękuję.'
  },
  {
    id: 'andrzej-bachleda-curus',
    kind: 'chat',
    source: 'discord',
    author: 'Andrzej',
    role: 'Stanford University',
    tone: 'emerald',
    timestamp: '18.04.2026, 11:04',
    content:
      '(...) Szczerze, nie spotkałem się jeszcze z takim zaangażowaniem ze strony nauczyciela. Dzięki tobie się udało :)'
  }
]
